'use client';
import { useReducedMotion } from 'framer-motion';
import { useIsMobile } from './useIsMobile';

// Returns false only when we know the user is on mobile or has reduced
// motion enabled. Defaults to true (animate) before hydration so desktop
// entrance animations aren't killed on first paint.
export function useShouldAnimate() {
  const isMobile = useIsMobile();
  const prefersReduced = useReducedMotion();
  return isMobile !== true && prefersReduced !== true;
}
